export default __webpack_public_path__ + "static/media/hat.6938c44a.svg";